import React, { useState } from "react";
import ALhana from "../Assets/alhana_center_2.webp";
import AlGarhoud from "../Assets/garhoud_villa_main.webp";
import Alrashidiyya from "../Assets/rashidiyya_villa.webp";
import jaffiliya from "../Assets/jaffiliya_villa_1.webp";
import Nouftower from "../Assets/nouf_tower_front.webp";
import logo from "../Assets/logowhtbg.png";     
import Grovecourt from "../Assets/Grove_court_2.webp";





const historyData = [
  {
    range: "1992",
    events: [
      {
        year: "1992",
        title: "Al Qouz Complex",
        description:
          "Al Qouz Complex Commercial Established in 1992, featuring a three-story building, mosque, and 40 warehouses for commercial",
        image: ALhana,
      },
    ],
  },
  {
    range: "1994",
    events: [
      {
        year: "1994",
        title: "Foundation",
        description:
          "Back in 1994, Mohammed Saeed Khalaf Al Gaith founded the company,setting in motion the vision and ambition that shaped the thriving Group we are proud to be today.",
        image: logo,
      },
      {
        year: "1994",
        title: "Al Garhoud 6 Villa Complex",
        description:
          "AlGarhoud 6 Villa Complex,established in 1994, is a secure and stylish community offering comfort and elegance.",
        image: AlGarhoud,
      },
      {
        year: "1994",
        title: "AL Hana Center",
        description:
          "Alhana Center, established in 1994, is a premier multi-level commercial destination in Al Jafiliya, perfect for retail and business.",
        image: ALhana,
      },
    ],
  },
  {
    range: "1998",
    events: [
      {
        year: "1998",
        title: "Jumeirah 6 Villas Complex,",
        description:
          "Jumeirah 6 Villas Complex, established in 1998, is a luxurious six-villa development in Jumeirah Third with privategardens, pools, and dedicatedparking.",
        image: "/images/diversification.jpg",
      },
    ],
  },
  {
    range: "2000",
    events: [
      {
        year: "2000",
        title: "Al Rashidiya 10 Villa Complex,",
        description:
          "Al Rashidiya 10 Villa Complex, established in 2000, is a stylish residential community with ten villas, private gardens, a shared pool, and dedicated parking.",
        image: Alrashidiyya,
      },
    ],
  },
   {
    range: "2003",
    events: [
      {
        year: "2003",
        title: "Hudaiba Building",
        description:
          "Hudaiba Building, established in 2003 in Al Hudaiba, is a mixed-use property featuring retail shops, 18 apartments, 47 parking spaces, and a rooftop.",
        image: "/images/expansion.jpg",
      },
    ],
  },
  {
    range: "2009",
    events: [
      {
        year: "2009",
        title: "Nouf Tower",
        description:
          "Nouf Tower, established in 2009 in Port Saeed, is a premium commercial high-rise with showrooms, 54 offices, ampleparking, and a rooftop.",
        image: Nouftower,
      },
    ],
  },
  {
    range: "2011",
    events: [
      {
        year: "2011",
        title: "Ras Al Khour 31 Warehouse Complex",
        description:
          "Ras Al Khour 31 Warehouse Complex, established in 2011, is a secure commercial hub with 31 warehouses and on-site amenities.",
        image: "/images/expansion.jpg",
      },
    ],
  },
  {
    range: "2013",
    events: [
      {
        year: "2013",
        title: "Jumeirah Grove Court",
        description:
          "Jumeirah Grove Court, established in 2013, offers 14 luxurious villas in Jumeirah Third with private pools, gardens, and parking.",
        image: Grovecourt 
      },
    ],
  },
  {
    range: "2014",
    events: [
      {
        year: "2014",
        title: "Jafiliya 12 Villa Complex,",
        description:
          "Experience luxury living at Al Jafiliya 12 Villa Complex, established in 2014, with pools, gardens, and parking.",
        image: jaffiliya,
      },
    ],
  },
];

const TimelineSection = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <section className="w-full bg-blue-900 text-white py-16">
      <div className="container mx-auto px-4">
        {/* Desktop Layout */}
        <div className="hidden md:flex mx-14 pl-14 flex-row">
          {/* Left Timeline (Vertical) */}
          <div className="w-1/3 pr-6 relative">
            {/* Vertical line */}
            <div className="absolute left-2 top-0 bottom-0 w-0.5 bg-gray-500"></div>

            <ul className="space-y-8 relative">
              {historyData.map((item, index) => (
                <li
                  key={index}
                  className="flex items-center cursor-pointer"
                  onClick={() => setSelectedIndex(index)}
                >
                  {/* Dot */}
                  <div
                    className={`w-4 h-4 rounded-full border-2 ${
                      selectedIndex === index
                        ? "bg-light-blue border-light-blue "
                        : "bg-blue-900 border-gray-400"
                    }`}
                  ></div>
                  {/* Year text */}
                  <span
                    className={`ml-6 text-xl font-medium transition ${
                      selectedIndex === index
                        ? "text-light-blue "
                        : "text-gray-300 hover:text-light-blue "
                    }`}
                  >
                    {item.range}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Content */}
          <div className="w-2/3 pl-6 space-y-12">
            {historyData[selectedIndex].events.map((event, i) => (
              <div
                key={i}
                className="flex flex-col md:flex-row items-start gap-6"
              >
                {/* Image with frame */}
                <div className="relative">
                  <div className="absolute -bottom-3 -left-3 w-full h-full bg-light-blue  rounded-md"></div>
                  <img
                    src={event.image}
                    alt={event.title}
                    className="relative w-64 h-40 object-cover rounded-md shadow-lg"
                  />
                </div>

                {/* Text */}
                <div>
                  <h3 className="text-2xl font-bold text-light-blue mb-2">
                    {event.year}
                  </h3>
                  <p className="text-lg font-semibold mb-2">{event.title}</p>
                  <p className="text-gray-200 leading-relaxed">
                    {event.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden">
          {/* Horizontal Timeline */}
          <div className="flex justify-between items-center border-b border-gray-500 pb-4 overflow-x-auto">
            
            {historyData.map((item, index) => (
              <button
                key={index}
                className={`flex flex-col items-center text-sm px-2 ${
                  selectedIndex === index ? "text-light-blue " : "text-gray-300"
                }`}
                onClick={() => setSelectedIndex(index)}
              >
                <div
                  className={`w-3 h-3 rounded-full border-2 mb-1 ${
                    selectedIndex === index
                      ? "bg-light-blue border-light-blue"
                      : "bg-blue-900 border-gray-400"
                  }`}
                ></div>
                {item.range}
              </button>
            ))}
          </div>

          {/* Events below */}
          <div className="mt-8 space-y-8">
            {historyData[selectedIndex].events.map((event, i) => (
              <div key={i} className="flex flex-col gap-4">
                {/* Image with frame */}
                <div className="relative self-center">
                  <div className="absolute -bottom-3 -left-3 w-full h-full bg-light-blue  rounded-md"></div>
                  <img
                    src={event.image}
                    alt={event.title}
                    className="relative w-full max-w-xs object-cover rounded-md shadow-lg"
                  />
                </div>

                {/* Text */}
                <div>
                  <h3 className="text-xl font-bold text-light-blue  mb-1">
                    {event.year}
                  </h3>
                  <p className="text-base font-semibold mb-1">{event.title}</p>
                  <p className="text-gray-200 leading-relaxed text-sm">
                    {event.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;
